//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"BlendMiter",1,0],[1,"BlendMiterRadius",0,"Expression",0],[0,"ClosureType",1,0],[0,"CutMethod",1,0],[1,"Diameter",0,"Expression",0],[1,"Gap",0,"Expression",0],[1,"Length",0,"Expression",0],[1,"Length1",0,"Expression",0],[1,"Length2",0,"Expression",0],[0,"LimitEdge1",0,"ScCollector",0],[0,"LimitEdge2",0,"ScCollector",0],[0,"MiterCorner",1,0],[1,"Offset",0,"Expression",0],[0,"Origin",1,0],[1,"Overlap",0,"Expression",0],[0,"OverlapType",1,0],[1,"PunchRadius",0,"Expression",0],[1,"RectangularLength",0,"Expression",0],[1,"RectangularWidth",0,"Expression",0],[0,"TreatmentType",1,0],[0,"Type",1,0],[1,"VAngle1",0,"Expression",0],[1,"VAngle2",0,"Expression",0]],[[["first_face","second_face"],"AddFacePair",{},2,0],[["index","first_face","second_face"],"GetFacePair",{},1,0],[[],"GetNumberOfFacePairs",{R_:{number_of_face_pairs:''}},0,0],[[],"ValidateBuilderData",{R_:{validity:''}},0,0],[["first_face","second_face"],"RemoveFacePair",{},2,0],[["firstBendFace","secondBendFace"],"GetCornerEdge",{R_:{cornerEdge:"Edge"}},2,0]],[]];
SPLM.Features.SheetMetal.ClosedCornerBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.ClosedCornerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.ClosedCornerBuilder.Types = Object.freeze({
    "CloseAndRelief" : "CloseAndRelief", "Relief" : "Relief"});

SPLM.Features.SheetMetal.ClosedCornerBuilder.OverlapTypeOptions = Object.freeze({
    "None" : "None", "Side1" : "Side1", "Side2" : "Side2"});

SPLM.Features.SheetMetal.ClosedCornerBuilder.ClosureTypeOptions = Object.freeze({
    "Close" : "Close", "Overlap" : "Overlap"});

SPLM.Features.SheetMetal.ClosedCornerBuilder.TreatmentTypeOptions = Object.freeze({
    "Open" : "Open", "Closed" : "Closed", "CircularCutout" : "CircularCutout", "UCutout" : "UCutout", "VCutout" : "VCutout", "RectangularCutout" : "RectangularCutout"});

SPLM.Features.SheetMetal.ClosedCornerBuilder.OriginTypes = Object.freeze({
    "BendCenter" : "BendCenter", "CornerPoint" : "CornerPoint"});

SPLM.Features.SheetMetal.ClosedCornerBuilder.CutMethodTypes = Object.freeze({
    "ByTool" : "ByTool", "ByPath" : "ByPath"});

export default SPLM;